<p class="message" [innerHTML]="data?.error?.message"></p>
<!-- <div mat-dialog-content>
  <p [innerHTML]="confirmMessage"></p>
</div> -->
<div mat-dialog-actions>
  <button class="close" mat-button (click)="snackBarRef.dismiss()">X</button>
  <button class="detail" mat-button (click)="showDetail()">Mostra dettaglio</button>

</div>